export enum CaseImageType {
  DefectShoes = 'defect-shoe',
  InnerTagShoe = 'inner-tag-shoe',
  SolesShoe = 'soles-shoe',
  InnerTagApparel = 'inner-tag-apparel',
  DefectApparel = 'defect-apparel',
  InnerTagAccessories = 'inner-tag-accessories',
  DefectAccessories = 'defect-accessories',
}
